import { useEffect } from 'react';

export const handlePostMessage = () =>
  window.postMessage({ message: 'requestTab' }, window.location.origin);

const useOpenManageRequestJoinGroup = (cb: Function, continuePostMessage: boolean = true) => {
  useEffect(() => {
    const listen = (e: MessageEvent<any>) => {
      if (
        e.origin === window.location.origin &&
        e.data?.message === 'requestTab'
      ) {
        window.removeEventListener('message', listen);
        continuePostMessage && handlePostMessage();
        cb();
      }
    };

    window.addEventListener('message', listen);
    return () => {
      window.removeEventListener('message', listen);
    };
  }, [cb, continuePostMessage]);
};
export default useOpenManageRequestJoinGroup;
